// extracted by mini-css-extract-plugin
export var button = "_am-4";
export var hasDarkBackground = "_am-7";
export var hasLightBackground = "_am-6";
export var iconWrapper = "_am-0";
export var large = "_am-2";
export var medium = "_am-1";
export var small = "_am-5";
export var xsmall = "_am-3";